import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-sowhatbuy-card-image.js';

const BG_IMAGE = 'https://sowhatbuy.com/cdn/shop/files/20260331-bg2-pc.png';
const BG_IMAGE_MOBILE = 'https://sowhatbuy.com/cdn/shop/files/20260331-bg2.png';
const TAG_LED_BG = 'https://sowhatbuy.com/cdn/shop/files/20260331-p4-2-pc.png';
const TAG_BRIGHTNESS_BG = 'https://sowhatbuy.com/cdn/shop/files/20260331-p4-1-pc.png';

const defaultBoxes = [{ label: 'Low' }, { label: 'Medium' }, { label: 'High' }];

const renderBox = item => `
  <div
    class="sowhatbuy-card-image__box"
    data-attribute="sowhatbuy-card-image__box"
  >
    <div
      class="sowhatbuy-card-image__box-label"
      data-attribute="sowhatbuy-card-image__box-label"
    >${item.label}</div>
  </div>
`;

const contentHtml = `
  <div
    class="sowhatbuy-card-image container"
    data-attribute="sowhatbuy-card-image-content"
  >
    <div
      class="sowhatbuy-card-image__header"
      data-attribute="sowhatbuy-card-image__header"
    >
      <h2 style="text-align:center;"><span style="color:#d35400;font-size:48px;"><strong>Clear Even</strong></span><span style="font-size:50px;"> <strong>In Dim Light</strong></span></h2>
      <p style="text-align:center;">Soft, glare-free lighting for comfortable, eye-friendly reading.</p>
    </div>

    <div
      class="sowhatbuy-card-image__tag sowhatbuy-card-image__tag--brightness"
      data-attribute="sowhatbuy-card-image__tag-brightness"
      data-show="true"
      data-bg-image="${TAG_BRIGHTNESS_BG}"
      style="background-image: url(${TAG_BRIGHTNESS_BG});"
    >
      <span
        class="sowhatbuy-card-image__tag-text"
        data-attribute="sowhatbuy-card-image__tag-brightness-text"
      >3 Brightness Levels</span>
    </div>

    <div
      class="sowhatbuy-card-image__tag sowhatbuy-card-image__tag--led"
      data-attribute="sowhatbuy-card-image__tag-led"
      data-show="true"
      data-bg-image="${TAG_LED_BG}"
      style="background-image: url(${TAG_LED_BG});"
    >
      <span
        class="sowhatbuy-card-image__tag-text"
        data-attribute="sowhatbuy-card-image__tag-led-text"
      >10 High-CRI LED Lights</span>
    </div>

    <div
      class="sowhatbuy-card-image__boxes"
      data-attribute="sowhatbuy-card-image__boxes"
    >
      ${defaultBoxes.map(renderBox).join('\n')}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundImage: BG_IMAGE,
  useBackgroundMobile: true,
  backgroundImageMobile: BG_IMAGE_MOBILE,
  textColor: '#ffffff',
  topPadding: true,
  bottomPadding: true,
});
